import { SeriesId } from "@mui/x-charts/internals";
import {
  getValueToPositionMapper,
  useLineSeries,
  useXAxis,
  useYAxis,
} from "@mui/x-charts-premium";

export function useLinePoint(
  seriesId: SeriesId | undefined,
  dataIndex: number | undefined
) {
  const allSeries = useLineSeries();
  const series = allSeries.find((s) => s.id === seriesId) || allSeries[0];

  const xAxisId = series?.xAxisId;
  const yAxisId = series?.yAxisId;
  const xAxis = useXAxis(xAxisId);
  const yAxis = useYAxis(yAxisId);

  if (
    dataIndex === undefined ||
    series === undefined ||
    xAxis === undefined ||
    yAxis === undefined
  ) {
    // If there is not line series defined, we cannot show any point
    return null;
  }

  const value = series.data[dataIndex];
  const xValue = xAxis.data![dataIndex];
  if (value == null || xValue == null) {
    return null;
  }

  const x = getValueToPositionMapper(xAxis.scale)(xValue);
  const y = getValueToPositionMapper(yAxis.scale)(value);

  return { x, y, series, value, xValue };
}
